import { QueriesUtils } from "./queries.utils";

/**
 * Generates a GraphQL query to load an organisation based on specified parameters.
 *
 * @param {string} id - (Required) The organisation ID for which organisation is queried.
 * @param {OrganisationIncludes[]} include - Additional fields to include in the query.
 * @returns {string} The generated GraphQL query for loading an organisation.
 */
export const getOrganisationByIdGraphQLQuery = (
  id: string,
  include: OrganisationIncludes[] = [],
): string => {
  return `
{
    loadOrganisationById(   
    orgId: "${id}",
) {
        ${getOrganisationProperties(include)}             
    }
}
`;
};

export const getOrganisationProperties = (include: OrganisationIncludes[]): string => {
  return `
    id
    name
    website
    ${QueriesUtils.getQueryIncludes(include)}
    `;
};

export type OrganisationIncludes = "CERTIFICATES" | "DOCUMENTS" | "FULL_ADDRESS";
